var map;
var infowindow;
var markers = [];
var iconhubs="https://static.delti.com/static/rdaru/media/dpd_logo.png";

var transportationHubOptions = {
    isSelectedTransportationHub: false
}

var styles = [
    {
        stylers: [
            { hue: "#00ffe6" },
            { saturation: -20 }
        ]
    },{
        featureType: "road",
        elementType: "geometry",
        stylers: [
            { lightness: 100 },
            { visibility: "simplified" }
        ]
    },{
        featureType: "road",
        elementType: "labels",
        stylers: [
            { visibility: "off" }
        ]
    }
];

function getPolygon() {
    var polygonCoords = [];

    for (var i=0; i < transportationHubs.length; i++) {
        var place = transportationHubs[i];
        polygonCoords.push([place.lat, place.long]);
    }
    var polygon = L.polygon(polygonCoords);

    // The Center of the polygon
    return polygon;
}

function drawLeafletMap(){

    if (!$('#map-canvas').length) {
        return;
    }

    var polygon = getPolygon();

    if (map && map._containerId) {
        map.off();
        map.remove();
    } else {
        map = null;
    }

    map = L.map('map-canvas', {
        zoomControl: false
    }).fitBounds(polygon.getBounds());

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);

    map.addControl(L.control.zoom({ position: 'bottomleft' }));

    for (var i=0; i < transportationHubs.length; i++) {
        var place = transportationHubs[i];
        place.index = i;

        L.marker([place.lat, place.long], {
            title: place.company,
            icon: L.icon({iconUrl: iconhubs}),
            options: {
                placeId: place.id
            }
        })
            .bindPopup(buildInfoStringHubs(place, true))
            .addTo(map)
            .on('click', function (ev) {
                scrollToTransportationHubs(ev.target._latlng);
                $(".partnerDetailsPopup").off();
                $(".partnerDetailsPopup").on("click", function(event) {
                    if (0 < document.getElementsByClassName("mp_main").length) {
                        ajaxLoading(this, $(this).data("action"), event, onClosePopupFunctionDefault);
                    } else {
                        ajaxLoading(this, $(this).data("action"), event, CheckoutServicePartnerJs.onCloseStep1Function);
                    }
                });
            })
            .on('mouseover', function (ev) {
                ev.target.setIcon(L.icon({iconUrl: iconhubs}));
            })
            .on('mouseout', function (ev) {
                ev.target.setIcon(L.icon({iconUrl: iconhubs}));
            });
    }

    $(window).on('resize', function() {
        drawLeafletMap();
    });
}

function scrollToTransportationHubs(marker){
    var allHubs = document.getElementsByClassName("hidden-div-id-for-scrolling");
    var results = [];
    for(var k=0; k<allHubs.length; k++) {
        allHubs[k].parentNode.parentNode.parentNode.style.backgroundColor = '';

        if (allHubs[k].innerText == marker.lat + "" + marker.lng) {
            allHubs[k].parentNode.parentNode.parentNode.style.backgroundColor = 'rgba(70, 120, 170, 0.1)';
            results.push(allHubs[k]);
        }
    }

    var destination = "";

    if (0 < results.length) {
        destination = results[0].parentNode.childNodes[1].offsetTop;
    }

    $('.sp_list').animate({ scrollTop: destination - 60}, 1000);
}

function initializeTransportationHubs() {

    markers = [];

    if(typeof transportationHubs === 'undefined' || transportationHubs.length === 0) {
        return;
    }

    if (ACC.servicePartnersEngine === "leaflet") {
        drawLeafletMap();
        return;
    }

    $( "#colorbox" ).on({
        mouseover: function() {
            var details = $(this).find(".partner-index-btn");
            var index = details.data('index');
            var marker = markers[index];

            marker.setIcon(iconhubs);
        },
        mouseout: function() {
            var details = $(this).find(".partner-index-btn");
            var index = details.data('index');
            var marker = markers[index];

            marker.setIcon(iconhubs);
        }
    }, '.partner-result');
}

function buildInfoStringHubs(place, disableScroll) {
    var infoString = $.tmpl($('#tmpl-info'), place).html();
    if (!disableScroll) {
        scrollToServiceHubs(place);
    }
    return infoString;
}

function scrollToServiceHubs(marker){
    var allHubs = document.getElementsByClassName("hidden-div-id-for-scrolling");
    var results = [];
    for(var k=0; k<allHubs.length; k++) {
        allHubs[k].parentNode.parentNode.parentNode.style.backgroundColor = '';

        if (allHubs[k].innerText == marker.lat + marker.long) {
            allHubs[k].parentNode.parentNode.parentNode.style.backgroundColor = 'rgba(70, 120, 170, 0.1)';
            results.push(allHubs[k]);
        }
    }

    var destination = "";

    if (0 < results.length) {
        destination = results[0].parentNode.childNodes[1].offsetTop;
    }

    $('.sp_list').animate({ scrollTop: destination - 60}, 1000);
}


function ajaxTrHubsLoading(currentElement, url, event, onClosePopupFunction, successFunction) {
    var form = $(currentElement).closest("form");
    event.preventDefault();
    loadTransportationHubsPopupAjax(form, url, onClosePopupFunction, successFunction);
}

function loadTransportationHubsPopupAjax(form, url, onClosePopupFunction, successFunction) {
    $.ajax({
        url: url,
        type: "GET",
        cache: false,
        data: $(form).serialize(),
        success: function(data) {
            $.fancybox({
                width:1050,
                height:700,
                content : data,
                fitToView : true,
                autoSize : false,
                afterClose: onClosePopupFunction,
                helpers : {
                    overlay : {
                        locked : false
                    }
                }
            });
            if (typeof(successFunction) != "undefined") {
                successFunction();
            }
        }
    }).done(function() {
        initializeTransportationHubs();
        initTransportationHubsActions(onClosePopupFunction);
    }) ;
}

$(document).ready(function() {
    $(".trHubsSearchSubmit").on("click", function(event) {
        ajaxTrHubsLoading(this, $(this).data("action"), event);
    });

    $(document).on("click", ".j-trhubconfirmation-close", function(event) {
        $.fancybox.close();
    });
});

function initTransportationHubsActions(onClosePopupFunction) {
    $("#trHubsMainContent .trHubsSearchSubmit").off();
    $("#trHubsMainContent .trHubsSearchSubmit").on("click", function(event) {
        ajaxTrHubsLoading(this, $(this).data("action"), event, onClosePopupFunction);
    });

    $(".partnerDetails").off();
    $(".partnerDetails").on("click", function(event) {
        ajaxTrHubsLoading(this, $(this).data("action"), event, onClosePopupFunction);
    });

    $(".trHubConfirmation").off();

    $(".trHubConfirmation").on("click", function(event) {

        var $this = $(this);

        var onConfirmFunction = function(){
            transportationHubOptions.isSelectedTransportationHub = true;

            var $partnerResultElement = $this.closest(".partner-result");

            transportationHubOptions.street = $partnerResultElement.find(".j-partner-company-street").text();
            transportationHubOptions.city = $partnerResultElement.find(".j-partner-company-city").text();
            transportationHubOptions.zip=$partnerResultElement.find(".j-partner-company-zip").text();
            transportationHubOptions.phone=$partnerResultElement.find(".j-partner-company-phone").text();
            transportationHubOptions.code=$partnerResultElement.find(".j-partner-company-code").text();

        }

        ajaxTrHubsLoading(this, $this.data("action"), event, onClosePopupFunction, onConfirmFunction);
    });

    $("#back").off();
    $("#back").on("click", function(event) {
        ajaxTrHubsLoading(this, $(this).data("action"), event, onClosePopupFunction);
    });
    $("#changeTrHubSelection").off();
    $("#changeTrHubSelection").on("click", function(event) {
        ajaxTrHubsLoading(this, $(this).data("action"), event, onClosePopupFunction);
    });

};